// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dY7w","content":"styles_content__3SdQP","row":"styles_row__aKtsS","footer":"styles_footer__26tSn","phraseLength":"styles_phraseLength__1sOFR"};